// トップの背景動画を、条件が整ったときだけ読み込む
//
// 開いた瞬間に動画を取りにいくのはやめ、表示が落ち着いてから読む。
// スマホの初回表示が遅くなる最大の原因だったため、次の条件を満たすときだけ読む。
//   ・狭い画面には720px幅・2MBの軽い方を渡す（以前は読まなかった）
//   ・通信が細くない／データ節約がオフ
//   ・「動きを減らす」設定でない
// 読まない場合は、背景の静止画がそのまま見える。
(function () {
	function start() {
		var v = document.querySelector('.js-bg-video');
		if (!v || !v.dataset.src) return;

		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		var c = navigator.connection;
		if (c && (c.saveData || /^(slow-)?2g$/.test(c.effectiveType || ''))) return;

		// スマホでも流す。ただし6MBをそのまま送ると通信量と表示速度に響くため、
		// 狭い画面には720px幅・2MBの軽い方を渡す。
		v.src = (window.innerWidth < 768 && v.dataset.srcSp) ? v.dataset.srcSp : v.dataset.src;
		v.load();
		var p = v.play();
		if (p && p.catch) { p.catch(function () {}); }
		v.classList.add('is-playing');
	}

	// 表示が落ち着いてから。ブラウザが暇なときに回す
	if ('requestIdleCallback' in window) {
		window.addEventListener('load', function () { requestIdleCallback(start, { timeout: 3000 }); });
	} else {
		window.addEventListener('load', function () { setTimeout(start, 1200); });
	}
})();
